export default "__VITE_ASSET__ee382df1__"